import React from "react";
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab'; // Corrected import
import Spinner from 'react-bootstrap/Spinner';

import { useSearchParams  } from "react-router-dom";

import PropertyList from "./PropertyList";
import DataCompare from "./DataCompare";
import ChangeLog from "./ChangeLog";
import ChangeLog2 from "./ChangeLog2";
import PhotoGrid from "./PhotoGrid";
import { useVehicleContext } from "../VehicleContext";
import { pickComparisonSourceVehicle } from "../../../lib/cvi2SourceVehicle";

function mkTab(eventKey, title, watch, children) {
    let status = watch && watch.status;

    if (!status || status === "NONE")
        return <></>;

    let inner = children;
    if (status === "LOADING") {
        inner = <Spinner animation="border" />;
        title = <>{title} <Spinner animation="border" size="sm" /></>;
    }
    if (status === "ERROR") {
        inner = <div style={{color: "red"}}>Error loading data.  Please try again.</div>;
        title = <>{title} <span style={{color: "red"}}>!</span></>;
    }
    return <Tab eventKey={eventKey} title={title}>
        {inner}
    </Tab>;
}

function VehicleDetails(props) {
    const context = useVehicleContext();
    const [searchParams, setSearchParams] = useSearchParams();

    const selectedTab = searchParams.get("tab") || "cmp";
    const setSelectedTab = (key) => {
        setSearchParams((prev) => {prev.set("tab", key); return prev;});
    }

    let oem = null;
    if (context.cviSvsVehicle.data && context.cviSvsVehicle.data.dealerVehicle && context.cviSvsVehicle.data.dealerVehicle.oemComplianceBlob) {
        try {
            oem = JSON.parse(context.cviSvsVehicle.data.dealerVehicle.oemComplianceBlob);
        } catch (error) {
            console.warn('Invalid JSON in oemComplianceBlob:', error.message);
            oem = null;
        }
    }

    // Prepare allAvailableData for DataCompare component
    // Pass full context objects (including status) so DataCompare can detect loading state
    const allAvailableData = {
        VAUTO: context.vaCoreVehicle,
        CVI: context.cviSvsVehicle,
        // One CVI 2.1 column, but the record carries one copy of the vehicle per incoming
        // channel, so the column needs one of them. The CVI 2.1 tab below still renders the
        // record as the Inventory Records Service returned it.
        CVI2: pickComparisonSourceVehicle(context.cvi2Vehicle),
        MVS: context.vaMvsVehicle,
        IOL: context.iolVehicle,
        DDC: context.ddcVehicle,
        VINSOL: context.vinVehicle,
        ATC: context.atcVehicle,
        VADIVA: context.cviVaDivaVehicle,
        CVM: context.cviCvmVehicle
    };

    const sourceOrdering = ["VINSOL", "CVI", "CVI2", "DDC", "VAUTO", "ATC", "IOL", "MVS", "VADIVA", "CVM"]; // Define the desired source ordering
    return <div className="vehicle-details">
        <Tabs activeKey={selectedTab} onSelect={(key) => setSelectedTab(key)} id="vehicle-details-tabs">
            {mkTab("cmp", "Data Compare", {status: "READY"}, <DataCompare allAvailableData={allAvailableData} sourceOrdering={sourceOrdering} />)}
            {mkTab("va", "vAuto", context.vaCoreVehicle, <PropertyList obj={context.vaCoreVehicle.data} />)}
            {mkTab("cavi", "CVI 1.0", context.cviSvsVehicle, <PropertyList obj={context.cviSvsVehicle.data} />)}
            {mkTab("cavi2", "CVI 2.1", context.cvi2Vehicle, <PropertyList obj={context.cvi2Vehicle.data} />)}
            {mkTab("changelog", "Change Log - CVI1", context.cviChangeLog, <ChangeLog changeLog={context.cviChangeLog.data} />)}
            {mkTab("logentries", "Audit Log - CVM", context.cviVehicleLogEntries, <ChangeLog2 changeLog={context.cviVehicleLogEntries.data} />)}
            {mkTab("mvs", "Merch", context.vaMvsVehicle, <PropertyList obj={context.vaMvsVehicle.data} />)}
            {mkTab("media", "CVM", context.cviCvmVehicle, <PropertyList obj={context.cviCvmVehicle.data} />)}
            {mkTab("photos", "Photos", context.cviCvmVehicle, <PhotoGrid cvm={context.cviCvmVehicle.data} />)}     
            {mkTab("vinsol", "VinSolutions", context.vinVehicle, <PropertyList obj={context.vinVehicle.data} />)}
            {mkTab("ddc", "Dealer.com", context.ddcVehicle, <PropertyList obj={context.ddcVehicle.data} />)}
            {mkTab("oem", "Raw OEM", oem, <PropertyList obj={oem} />)}
            {mkTab("iol", "Raw IOL", context.iolVehicle, <PropertyList obj={context.iolVehicle.data} />)}
            {mkTab("atc", "Raw ATC", context.atcVehicle, <PropertyList obj={context.atcVehicle.data} />)}
            {mkTab("vadiva", "Raw vA DIVA", context.cviVaDivaVehicle, <PropertyList obj={context.cviVaDivaVehicle.data} />)}
        </Tabs>
        </div>
}

export default VehicleDetails;
